import {
    Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges
} from '@angular/core';
import { DatePipe } from '@angular/common';

import { saveAs } from 'file-saver';
import { ILot } from 'src/app/models/generic';
import { SnackbarType } from 'src/app/models/snackbar-type.enum';
import { SnackbarService } from 'src/app/services/snackbar.service';

import { AnnexEnum, IAnnex } from '../../../models/annex';
import { ApiLotsService } from '../../../services/api/api-lots.service';
import { ApiManualBatchService } from '../../../services/api/api-manual-batch.service';
import { DocumentValidator } from '../../validators/document.validator';

@Component({
  selector: 'app-c-anexo',
  templateUrl: './c-anexo.component.html',
  styleUrls: ['./c-anexo.component.scss']
})
export class CAnexoComponent implements OnInit, OnChanges {
  @Input() batch!: ILot;
  @Input() invoiceFile!: Blob | string | null;
  @Input() authorizationFile!: Blob | string | null;
  @Input() batchType!: 'invoice' | 'transfer';
  @Input() transferType: 'manual' | 'automatic' = 'automatic';
  @Input() index: number = 0;
  @Input() appearance: 'legacy' | 'modern' = 'legacy';

  @Output() handleSelectFileEvent = new EventEmitter<{
    event: Event;
    fileName: string;
  }>();

  Annex = AnnexEnum;
  anexos: IAnnex[] = [];

  annexList: IAnnex[] = [
     {
      Title: this.Annex.AutorizacaoRepasse,
      File: '',
      isLoader: false,
      visible: false,
      Id: 'autorizacao',
      AllowDownload: false,
      DisableUpload: false,
    },
    {
      Title: this.Annex.NotaFiscal,
      File: '',
      isLoader: false,
      visible: false,
      Id: 'notaFiscal',
      AllowDownload: false,
      DisableUpload: false,
    },
    {
      Title: this.Annex.MemoriaCalculo,
      File: '',
      isLoader: false,
      visible: false,
      Id: 'memoria',
      AllowDownload: false,
      DisableUpload: false,
    },
    {
      Title: this.Annex.Rpa,
      File: '',
      isLoader: false,
      visible: false,
      Id: 'rpa',
      AllowDownload: false,
      DisableUpload: false,
    }
  ];

  file: Blob | string | null = null;

  annexTextFile: { [key: string]: string } = {
    [AnnexEnum.AutorizacaoRepasse]: 'AutorizaçãoDeRepasse.pdf',
    [AnnexEnum.NotaFiscal]: 'NotaFiscal.pdf',
    [AnnexEnum.MemoriaCalculo]: 'MemóriaDeCalculo.pdf',
    [AnnexEnum.Rpa]: 'Rpa.pdf'
  };

  downloadFileMethod: { [key: string]: Function } = {
    [AnnexEnum.AutorizacaoRepasse]: this.getAuthorizationFile,
    [AnnexEnum.NotaFiscal]: this.getInvoiceFile,
    [AnnexEnum.MemoriaCalculo]: this.getCalculationFile,
    [AnnexEnum.Rpa]: this.getRpaFile
  };

  constructor(
    private _apiBatchService: ApiLotsService,
    private snackbarService: SnackbarService,
    private _manualBatchService: ApiManualBatchService,
    private _datePipe: DatePipe
  ) { }

  get hasDownloadableAnnex(): boolean {
    return this.anexos.some((anexo) => anexo.visible && anexo.AllowDownload);
  }

  modernLabel(anexo: IAnnex): string {
    if (anexo.Title === this.Annex.NotaFiscal && this.batch?.InvoiceNumber)
      return `${anexo.Title} ${this.batch.InvoiceNumber}`;

    return anexo.Title;
  }

  modernEmittedCaption(anexo: IAnnex): string {
    if (anexo.Title !== this.Annex.NotaFiscal || !this.batch?.InvoiceDate) return '';

    const formatted = this._datePipe.transform(this.batch.InvoiceDate, 'dd/MM/yyyy');
    return formatted ? `emitida em ${formatted}` : '';
  }

  ngOnInit(): void { 
    this.anexos = this.annexList.filter(x => x.Id != 'autorizacao');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['batch'] && this.batch?.BatchId) {

      if (this.batch?.IsInvoiced || (this.batch?.InvoiceNumber && this.batchType === 'invoice'))
        this.annexList[1].AllowDownload = true;

      this.verifyHasInvoiceFile();

      if (this.batchType === 'transfer') {

        if (this.batch.DocuSignContractId){
          this.annexList[0].DisableUpload = true;
        }

        if (this.batch.Calculations)
          this.annexList[2].AllowDownload = true;

        if (this.batch.HasRpa){
          this.annexList[3].AllowDownload = true;
          this.annexList[3].DisableUpload = true;
        }

        this.verifyHasCalculationFile();
      }

      if (this.batch.EconomicGroupAutorizationFile)
        this.annexList[0].AllowDownload = true;

    }

    if (changes['authorizationFile'] && this.authorizationFile) {
      this.annexList[0].File = this.authorizationFile;
      this.annexList[0].AllowDownload = !!this.authorizationFile;
    }

    if (changes['invoiceFile'] && this.invoiceFile) {
      this.annexList[1].File = this.invoiceFile;
      this.annexList[1].AllowDownload = !!this.invoiceFile;
    }

    if (changes['batchType'] && this.batchType) {
      let isCpf: boolean = this.batch.PartnerDocument != null && DocumentValidator.isCPF(this.batch.PartnerDocument);
      let isTransfer: boolean = this.batchType === 'transfer';

      this.annexList[0].visible = isTransfer;
      this.annexList[1].visible = isTransfer && !isCpf || (this.batchType === 'invoice' && !!this.batch?.InvoiceNumber);
      // Tarefa: 1314
      //this.annexList[2].visible = isTransfer;
      this.annexList[2].visible = false;
      this.annexList[3].visible = isTransfer && isCpf;
    }
  }

  verifyHasInvoiceFile(): void {

    if (!this.batch.IsInvoiced && this.batchType === 'transfer' && this.transferType !== 'manual')
      this.snackbarService.openSnackBar('NF ainda não inserida ao lote!', SnackbarType.Warn);

  }

  verifyHasCalculationFile(): void {

    if (!this.batch.Calculations)
      this.snackbarService.openSnackBar('Memória de Cálculo não vinculada ao lote!', SnackbarType.Warn);

  }

  handleDownloadFile(file: Blob | string | null, title: string): void {
    let downloadMethod: Function = this.downloadFileMethod[title].bind(this);
    downloadMethod();
  }

  getAuthorizationFile(): void {
    this.annexList[0].isLoader = true;
    this._manualBatchService
      .getAuthorizationFile(this.batch.BatchId.toString())
      .subscribe({
        next: (response) => {
          this.file = response;
          this.annexList[0].File = this.file;
          this.annexList[0].isLoader = false;
          this.downloadFile(this.annexList[0].File, this.annexList[0].Title);
        },
        error: (error) => {
          this.annexList[0].isLoader = false;
          this.snackbarService.openSnackBar(
            'Erro ao buscar Autorização de Repasse!',
            SnackbarType.Danger
          );
        }
      });
  }

  getInvoiceFile(): void {
    this.annexList[1].isLoader = true;
    this._apiBatchService
      .getInvoiceFile(this.batch.BatchId.toString(), this.batchType)
      .subscribe({
        next: (response) => {
          this.file = response;
          this.annexList[1].File = this.file;
          this.annexList[1].isLoader = false;
          this.downloadFile(this.annexList[1].File, this.annexList[1].Title);
        },
        error: (error) => {
          this.annexList[1].isLoader = false;
          this.snackbarService.openSnackBar(
            'Erro ao buscar NF do lote!',
            SnackbarType.Danger
          );
        }
      });
  }

  getCalculationFile(): void {
    this.annexList[2].isLoader = true;
    this._apiBatchService
      .getCalculationFile(this.batch.BatchId.toString())
      .subscribe({
        next: (response) => {
          this.file = response;
          this.annexList[2].File = this.file;
          this.annexList[2].isLoader = false;
          this.downloadFile(this.annexList[2].File, this.annexList[2].Title);
        },
        error: (error) => {
          this.annexList[2].isLoader = false;
        }
      });
  }

  getRpaFile(): void {

    this.annexList[3].isLoader = true;
    this._apiBatchService
      .getRpaFile(this.batch.BatchId.toString(), this.batchType)
      .subscribe({
        next: (response) => {
          this.file = response;
          this.annexList[3].File = this.file;
          this.annexList[3].isLoader = false;
          this.downloadFile(this.annexList[3].File, this.annexList[3].Title);
        },
        error: (error) => {
          this.annexList[3].isLoader = false;
          this.snackbarService.openSnackBar(
            'Erro ao buscar RPA do lote!',
            SnackbarType.Danger
          );
        }
      });
  }

  selectFile(event: Event, fileName: string): void {
    this.handleSelectFileEvent.emit({ event, fileName: fileName });
  }

  downloadFile(file: Blob | string | null, title: string): void {
    let text: string = this.annexTextFile[title];

    if (file) {
      const blob = new Blob([file], { type: 'application/pdf' });
      saveAs(blob, text);
    } else {
      this.snackbarService.openSnackBar(
        'Houve um erro ao baixar o arquivo',
        'danger',
        5000
      );
    }
  }

  get diameter(): number {
    return this.transferType === 'automatic' ? 50 : 30;
  }
}
